import { isConsumerApp } from '@loggi/js/mobile';
import LoaderMask from '@loggi/ui/components/loader-mask';
import get from 'lodash/get';
import React from 'react';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import environment from 'shared/relay/environment';
import { PATH_PACKAGE_TRACKING } from 'tracker.routes';
import PackageStatusContainer from './package-status/package-status.container';
import packageTrackerQuery from './status.query';

/* eslint-disable react/prefer-stateless-function, react/jsx-props-no-spreading */
export default class Status extends React.Component {
  render() {
    const { props: statusProps } = this;
    const { trackingKey, companySecretId } = statusProps.match.params;
    return (
      <QueryRenderer
        environment={environment}
        query={packageTrackerQuery}
        variables={{ trackingKey, companySecretId, postalCode: null }}
        render={({ props, error }) => {
          if (props) {
            const currentStatus = get(
              props,
              'packageTracker.currentStatus',
              false
            );
            return currentStatus ? (
              <PackageStatusContainer viewer={props} {...statusProps} />
            ) : (
              <Redirect to={`${PATH_PACKAGE_TRACKING}`} />
            );
          }
          if (error) {
            return <Redirect to={`${PATH_PACKAGE_TRACKING}`} />;
          }

          // TODO: It is necessary to change this return to render a "Card" container
          // in order to avoid screen flashes
          return isConsumerApp() && <LoaderMask />;
        }}
      />
    );
  }
}
